export default __webpack_public_path__ + "assets/front/scss/affichage-mosaic.39bb8eb9f949d8dd40911aa67276ae7f.css";